
<nav class="navbar navbar-expand-lg shadow fixed-top vw-100"
  style="background-color: #ffeaa4; height: 73px; z-index: 1000">
  <div class="container-fluid">
    <a id="nav-brand-logo" class="navbar-brand px-4" [routerLink]="['/dashboard']" href="#"><img class="pe-3"
        src="./assets/images/images/logo.png" /><img style="height:40px; width: 100px;" src="./assets/images/TAeF2.png" /></a>
    <span style="font-size: 18px" class="fw-bold px-5 d-none d-md-inline ps-1 text-black">SISTEM e-FILING EJEN
      CUKAI</span>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse d-flex justify-content-end align-items-center" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item d-flex align-items-center pe-5">
          <a class="nav-link date-top-nav fw-bold text-black" style="font-size: 15px">{{ this.CurrentDate }}</a>
        </li>
        <li class="nav-item d-flex align-items-center">
          <div class="btn p-0" data-bs-toggle="modal" data-bs-target="#NotificationModal">
            <a class="link-dark position-relative">
              <img src="./assets/icons/bell-white-circle.svg" alt="user" />
              <span id="totalNoti" class="position-absolute top-0 translate-middle badge rounded-circle bg-danger" style="left: 90% !important">
                {{TotalAppointted}}
                <span class="visually-hidden">unread messages</span>
              </span>
            </a>
          </div>
        </li>
        <li class="nav-item d-flex align-items-center pe-3">
          <div class="btn p-0" data-bs-toggle="modal" data-bs-target="#LogoutModal">
            <a class="link-dark">
              <img src="./assets/icons/logout-circle-purple.svg" alt="logout" />
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!-- Notification Modal -->
<div class="modal fade" id="NotificationModal" tabindex="-1" aria-labelledby="NotificationModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style=" background-color: rgba(255, 255, 219, 0.9); border-radius: 1.7rem !important;">
      <div class="modal-header border-0">
        <p class="modal-title fw-bold mt-3">Lantikan Ejen Cukai</p>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <hr class="ms-3 me-3 mt-0" />
      <div class="modal-body">
        <p class="notifikasi-dropdown" style="font-size:15px;">Penerimaan Pelantikan Ejen Cukai <del style="color:transparent;">12</del>
          <span id="totalNotiInner" class="badge rounded-circle badge-colour ms-3 bg-danger" style="font-size:13px;">{{TotalAppointted}}</span>
          <span class="ms-5 badge text-dark" style="font-size: 0.58rem;">
            <a class="btn notification-btn shadow" data-bs-dismiss="modal" (click)="GoToApointted()">Papar</a>
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Logout Modal -->
<div class="modal fade" id="LogoutModal" tabindex="-1" aria-labelledby="LogoutModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="
        background-color: rgba(223, 224, 224, 0.9);
        border-radius: 1.7rem !important;
      ">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/logout-circle-purple.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk Log Keluar?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn btn-primary mx-3 bg-white text-black border-0 shadow" style="height: 35px; width: 102px"
              type="button" (click)="Logout()"> Ya </button>
            <button class="btn btn-primary mx-3 bg-white text-black border-0 shadow" data-bs-dismiss="modal" style="height: 35px; width: 102px"
              type="button"> Tidak </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
